var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useEffect } from "react";
import { useVortexContext } from "./vortexContext";
export const VortexCanvas = props => {
  const {
    vortexCanvasRef
  } = useVortexContext();
  const {
      children
    } = props,
    attributes = __rest(props, ["children"]);
  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => {
      // Clean up the canvas on unmount
      if (vortexCanvasRef === null || vortexCanvasRef === void 0 ? void 0 : vortexCanvasRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const canvas = vortexCanvasRef.current;
        canvas.width = 1;
        canvas.height = 1;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return React.createElement("canvas", Object.assign({
    ref: vortexCanvasRef,
    style: {
      maxWidth: "100%",
      maxHeight: "100%",
      minWidth: "100%",
      minHeight: "100%"
    }
  }, attributes), children);
};